<p class="mb-2">
    <b>With over 10 years’ auction finance experience, and common sense at the heart of our decision making, you can rely on us to move quickly. You’ll get:</b>
</p>



<ul class="bullets-teal">
    <li>an immediate online illustration of how much we could lend, putting you in the best possible position to bid at auction</li>
    <li>a full breakdown of the loan details, including all rates and fees. </li>
</ul>

<strong>It's important to remember:</strong>

<p>
    This will be an illustration based on the information you’ve provided and will be valid for two months. Our final decision to lend will only be made when you’ve submitted a full application and we’ve completed some final checks.
</p>



<together-auction-dip-stage-select [show_backward]="false" [show_action]="false" [show_forward]="true" [forward_title]="'Check your eligibility'" (on_forward)="onForwardClicked()"></together-auction-dip-stage-select>
